import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Menu, Dropdown } from 'antd';
import { css, cx } from 'emotion';
import { darkFont, getAnchorStyle } from 'styles/base';
import ContactUs from 'components/core/header/ContactUs';
import Logout from 'components/core/header/Logout';
import Login from 'components/core/header/Login';
import SecurityService from 'services/SecurityService';
import NavigationUtils from 'utils/NavigationUtils';

import logo from 'images/pcm-logo.png';

const dodUrl = process.env.REACT_APP_DOD_URL; // injected by Node.js build environment parameters
const processUrl = `${process.env.REACT_APP_WINDOW_URL}/processes`; // injected by Node.js build environment parameters
const searchUrl = `${process.env.REACT_APP_WINDOW_URL}/search`; // injected by Node.js build environment parameters

const logoBlock = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    #app-logo {
        padding-top: 3px;
        margin-top: 6px;
        height: 47px;
        width: auto;
    }
}
`;
const appTitle = css`
    ${darkFont}
    font-size: 26px;
    margin-left: 15px;
    color: white;
    display: flex;
    align-items: center;
`;
const caret = css`
    margin-left: 10px;
    font-size: 20px!important;
`;

/**
 * Renders the standard page header for PCM Process
 */
class PCMHeader extends React.Component {
    static propTypes = {
        userLoggedIn: PropTypes.bool,
        username: PropTypes.string,
        users: PropTypes.object,
        dependencyView: PropTypes.bool,
        searchView: PropTypes.bool,
    };

    getCurrentPageTitle = () => {
        let title = 'Process Manager';
        if (this.props.dependencyView) {
            title = 'Dependencies';
        } else if (this.props.searchView) {
            title = 'Search Code Catalog';
        }
        return title;
    };

    onArmClicked = () => {
        NavigationUtils.gotoHome(false);
    };

    renderNavigationMenu() {
        // If we are currently on the dependencies view, we must always reload the window because dependencies view
        // does not load security settings
        const searchFunc = this.props.dependencyView ? NavigationUtils.openExternalLinkInNewWindowFunc(searchUrl) : NavigationUtils.gotoSearchFunc();
        const processFunc = this.props.dependencyView ? NavigationUtils.openExternalLinkInNewWindowFunc(processUrl) : NavigationUtils.gotoHomeFunc();

        return (
            <Menu theme="dark">
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={NavigationUtils.openExternalLinkInNewWindowFunc(dodUrl)}>
                        DOD Manager
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={processFunc}>
                        Process Manager
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={searchFunc}>
                        Search Code Catalog
                    </a>
                </Menu.Item>
            </Menu>
        );
    }

    renderLogin() {
        if (!this.props.dependencyView) {
            return (
                <Login
                    username={this.props.username}
                    userLoggedIn={this.props.userLoggedIn}
                />);
        }
        return <div/>;
    }

    renderLogout() {
        if (this.props.userLoggedIn && !this.props.dependencyView) {
            return (
                <div className="main-menu-bar">
                    <Logout
                        username={this.props.username}
                        users={this.props.users}
                    />
                    <ContactUs
                        username={this.props.username}
                        users={this.props.users}
                    />
                </div>
            );
        }
        return <div/>;
    }

    render() {
        //okay you need to make this a state prop or something, not updating on location change which would make sense...

        // TODO: need to pass user logged in status to Login and Logout items
        return (
            <header role="banner">
                <div className={logoBlock}>
                    <a id="logo" rel="noopener noreferrer" title={'PCM Home'} onClick={NavigationUtils.gotoPcmHomeFunc()}>
                        <img id="app-logo" src={logo} alt="ARM PCM logo"/>
                    </a>
                    <div className="app-titles">
                        <Dropdown overlay={this.renderNavigationMenu()}>
                            <a className={cx(appTitle, getAnchorStyle('white'))}>
                                {this.getCurrentPageTitle()}
                                <i className={cx('fa fa-caret-down', caret)} aria-hidden="true"/>
                            </a>
                        </Dropdown>
                    </div>
                </div>
                {this.renderLogin()}
                {this.renderLogout()}
            </header>
        );
    }
}

// Automatically pull state information from the store and
// pass it to this component as props
const mapStateToProps = (storeState, ownProps) => {

    let userLoggedIn = null;
    let username = null;
    let users = null;

    // Don't show logged in status if we are on the dependency view page
    if (!ownProps.dependencyView) {
        const securityState = SecurityService.getMyState(storeState);
        userLoggedIn = securityState.userLoggedIn;
        username = securityState.username;
        users = securityState.users;
    }

    return {
        userLoggedIn,
        username,
        users
    };
};

export default connect(mapStateToProps)(PCMHeader);



// WEBPACK FOOTER //
// ./src/components/core/header/PCMHeader.js